module.exports = __webpack_public_path__ + "media/images/trinityfix_featured_speaker_background_column-3c6767e7.svg";